import { atom } from 'recoil'

export const defaultLoginValue: LoginUser = {
  id: -1,
  username: '',
  email: '',
  name: '',
  gender: 'MALE',
  nickname: '',
  birth: '',
  phone: '',
  code: '',
  profileUrl: '',
  avatarSlot: -1,
  authorities: ['ROLE_USER'],
  token: {
    accessToken: '',
    accessTokenExpiration: '',
  },
}
export const loginUserState = atom<LoginUser | null | undefined>({
  key: 'loginUserState',
  default: undefined,
})
